import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import UserMainApp from "../../layouts/UserMainApp";
import { AVATAR } from "../../images/images";
import { useSelector, useDispatch } from "react-redux";
import { userActions } from "../../../redux/actions";
import CourierMapWrapper from "../Riders/CourierMapWrapper";

export default function TrackView() {
  const { order_id } = useParams();
  const dispatch = useDispatch();

  // const orderDetails = useSelector(
  //   (state) => state?.users?.orderDetails?.data
  // );

  const orderDetails = useSelector(
    (state) => state?.users?.trackOrder?.data
  );

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  const riderDetails =
    orderDetails?.courier_orders[
      orderDetails.courier_orders?.length - 1
    ]?.courier;
  // const riderDetails =
  // trackOrder?.courier_orders[
  //   trackOrder.courier_orders?.length - 1
  // ]?.courier;

  // console.log("orderDetails", orderDetails);
  // console.log("riderDetails", riderDetails);

  useEffect(() => {
    const getOrderDetails = async () => {

      if (!order_id) return;

      try {
        await dispatch(userActions.trackOrder(order_id));
      } catch (error) {
        console.error("Failed to get second party order:", error);
      }
    };
    getOrderDetails();
  }, [dispatch, order_id])

  return (
    <UserMainApp>
      <div className="main-content">
        {/* ============ Body content start ============= */}

        <div className="row">
          <div className="col-md-8 p-0">
            <CourierMapWrapper rider={riderDetails} rider_company_id={orderDetails?.company_id} />
          </div>
          <div className="col-md-4 p-0">
            <div className="user-profile p-4">
              <a href="/user/trackOrder">Back</a>
              <div className="user-info mb-4">
                <img
                  className="profile-picture avatar-lg mb-2"
                  src={riderDetails?.courier_picture || AVATAR}
                  alt="rider"
                />
                <p className="m-0 text-24 text-capitalize">
                  {riderDetails?.courier_name || "No Courier Assigned"}
                </p>

                <p className="text-muted m-0">
                  Courier Details
                </p>
              </div>
              <div>
                {riderDetails ? (
                  <div className="user-info-card">
                    <ul>
                      <li>
                        <span>Name</span>{" "}
                        <span>{riderDetails?.courier_name}</span>
                      </li>
                      <li>
                        <span>Phone</span>{" "}
                        <span>{riderDetails?.courier_phone}</span>
                      </li>
                    </ul>
                  </div>
                ) : (
                  <p className="text-muted text-center">No courier assigned yet</p>
                )}
              </div>

              <div>
                <p className="text-muted text-center mt-5 mb-4">
                  Order Details
                </p>
                {orderDetails && (
                  <div className="user-info-card">
                    <ul>
                      <li>
                        <span>Order Id: </span>{" "}
                        <span> {orderDetails.id} </span>
                      </li>
                      <li>
                        <span>Status</span> <span>{orderDetails.status}</span>
                      </li>
                      <li>
                        <span>Order Amount</span>{" "}
                        <span>
                          {" "}
                          ₦
                          {orderDetails &&
                            orderDetails?.order_amount &&
                            numberWithCommas(orderDetails?.order_amount)}
                        </span>
                      </li>
                      <li>
                        <span>Payment Status</span>{" "}
                        {orderDetails.order_paid === true || orderDetails.order_paid === "true" ? (
                          <span className="badge badge-pill badge-outline-success p-2 m-1">
                            Paid
                          </span>
                        ) : (
                          <span className="badge badge-pill badge-outline-danger p-2 m-1">
                            Not paid
                          </span>
                        )}
                      </li>
                    </ul>
                  </div>
                )}
              </div>

              {orderDetails?.status === "unassigned" && (
                <h5 className="text-primary mt-5">
                  *Order has not been assigned to a courier yet*
                </h5>
              )}
            </div>
          </div>
        </div>
      </div>
    </UserMainApp>
  );
}
